module.exports = __webpack_public_path__ + "static/media/user-4.3718ec2b.jpg";